import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

& > button{
  margin-top: 20px;
  margin-bottom: 20px;
}

.action-limited{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.popup-form{
  display: flex;
  flex-direction: column;
  background-color: red;
}
`
